import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { API_URL } from "constants/ApiUrl";
import ClubService from "services/clubService";

export const getProfile = createAsyncThunk(
  "club/getProfile",
  async (_, { rejectWithValue }) => {
    try {
      const role = localStorage.getItem("role");
      const response = await ClubService.getProfile(role);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const getNotifications = createAsyncThunk(
  "club/getNotifications",
  async (_, { rejectWithValue }) => {
    try {
      const response = await ClubService.getNotifs();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateProfile = createAsyncThunk(
  "club/updateProfile",
  async (profileData, thunkAPI) => {
    try {
      const resp = await axios.put(`${API_URL}/api/club/profile`, profileData);
      return resp.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);


// Initial state
const initialState = {
  club: null,
  notifications: null,
  loading: false,
  error: null,
};

// Slice
const clubSlice = createSlice({
  name: "club",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // getProfile
    builder
      .addCase(getProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.club = action.payload;
      })
      .addCase(getProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload;
      })
      .addCase(updateProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(getNotifications.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.notifications = action.payload;
      })
      .addCase(getNotifications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default clubSlice.reducer;
